<!-- poor man's pie menu -->
<script>
    import Vue from "vue";

    export default {
        name: "CopyPrompt",
        data() {
            return {
                showing: false,
                site: null,
            };
        },
        methods: {
            notify(site) {
                this.site = site;
                this.showing = true;
            },

            clearClipboard() {
                navigator.clipboard.writeText("");
                this.showing = false;
            },

            dismissPrompt() {
                this.showing = false;
            },
        },
    };
</script>

<template>
    <!-- the action menu consists of 4 actions that map to keyboard's up-down-left-right; center is "back" -->
    <div v-show="showing" class="copy-prompt">
        <div class="contents">
            <div>
                Password for
                <span class="site-name">"{{ site }}"</span>
                has been copied to clipboard.
            </div>

            <button class="link" @click="dismissPrompt()">
                Dismiss
            </button>

            <button class="link" @click="clearClipboard()">
                Clear Clipboard
            </button>
        </div>
    </div>
</template>



<style lang="scss">
    .copy-prompt {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 900;
        font-size: 0.85em;

        .contents {
            max-width: 700px;
            margin: 1em auto;
            padding: 1em;
            border-radius: 5px;
            background: #333;
            color: #fff;

            display: flex;
            flex-wrap: wrap;

            align-items: center;
            box-shadow: 0px 0px 3px #333;

            & > div {
                flex-grow: 1;
                display: flex;

                .site-name {
                    display: inline-block;
                    max-width: 10em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0;
                    color: #999;
                    margin: 0 0.5em;
                }
            }

            button {
                padding: 0;
                color: $link-color;
                padding: 10px 1em;
                white-space: nowrap;
                margin-left: 0.5em;
            }
        }
    }
</style>
